import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './Component/navBar/navbar';
import Footer from './Component/footer/footer';
import Homepage from './Component/homepage/homepage';
import PressureFormer from './Component/presserformer/presserformer';
import Former from './Component/Former/Former';
import Cylinder from './Component/cylinder/cylinder';
import Spiderless from './Component/spiderless/spiderless';
import Blade from './Component/blade/blade';
import Coater from './Component/coater/coater';
import Size from './Component/size/size';
import Coating from './Component/coating/coating';
import Roll from './Component/roll/roll';
import Vat from './Component/vat/vat';
import Sparesandservices from './Component/Sparesandservices/Sparesandservices';
import Details from './Component/details/details';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/pressure-former-machine" element={<PressureFormer />} />
          <Route path="/1524mm-pressure-former-cylinder-gasket-manufacturers-in-india" element={<Former />} />
          <Route path="/cylinder-mould-paper-machine-manufacturers-in-india" element={<Cylinder />} />
          <Route path="/spiderless-cylinder-mould-manufacturers-in-india" element={<Spiderless />} />
          <Route path="/blade-bar-coater-coating-machine-unit-india" element={<Blade />} />
          <Route path="/bar-coater-v2-v3-bar-coating-machine-units-in-india" element={<Coater />} />
          <Route path="/size-press-paper-machine" element={<Size />} />
          <Route path="/coating-disperser-and-kitchen-equipment-manufacturers-suppliers-in-india" element={<Coating />} />
          <Route path="/roll-cleaner-cleaning-machine" element={<Roll />} />
          <Route path="/extractor-press-for-paper-mill-machine-manufacturers-in-gujarat-india" element={<Vat />} />
          <Route path="/Details" element={<Details />} />
          <Route path="/paper-machine-spare-parts-manufacturers-in-gujarat-india" element={<Sparesandservices />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
